// Path: ./src/app/pages/CreateNotificationPage/handleNotificationStore.ts
import { UpdateNotificationDto } from "@swagger/typescript-fetch-goflyer";
import { toastError, toastSuccess } from "../../../utils/pageUtil/toast";
import { messages } from "../../../locales/messages";
import { adminApiService } from "../../../utils/api";
import i18n from "i18next";
import { useLoading } from "../../../contextApi/LoadingContext";
import { useNavigate } from "react-router-dom";

export const useHandleSaveNotification = () => {
  const navigate = useNavigate();
  const { showLoadingScreen } = useLoading();
  const handleSaveNotification = async (
    updateNotification?: UpdateNotificationDto,
  ) => {
    if (!updateNotification?.title) {
      toastError(`Title ${i18n.t(messages.is_Empty())}`);
      return;
    }
    if (!updateNotification?.body) {
      toastError(`Body ${i18n.t(messages.is_Empty())}`);
      return;
    }

    showLoadingScreen(true);
    await adminApiService.notificationAdminControllerSendNotification({
      title: updateNotification.title,
      body: updateNotification.body,
      ...updateNotification, //This is for optional properties
    });
    showLoadingScreen(false);
    toastSuccess(
      `${i18n.t(messages.Create())} ${i18n.t(messages.Notifications())} `,
    );
    navigate(-1);
  };
  return handleSaveNotification;
};
